import React from 'react';
import {Link} from "react-router-dom";
import {getPartChartsDetail} from '../services/ExperimentService';
import {createChart} from '../services/ChartService';
import PartHistogramPanel from './components/PartHistogramPanel';
import PartBoxplotPanel from './components/PartBoxplotPanel';
import "../App.css";
import SectionHistogram from "./components/SectionHistogram";
import SectionBoxplot from "./components/SectionBoxplot";
import SectionTwoAfc from "./components/SectionTwoAfc";
import AlertBox from "./general/component/alertBox";
import SectionOutlier from "./components/SectionOutlier";

class PartChartsView extends React.Component {
    constructor(props) {
        super(props);
        let baseUrl = window.location.href;
        this.state = {
            id: baseUrl.substring(baseUrl.lastIndexOf('/') + 1),
            jwtToken: props.jwtToken,
            chartsData: null,

            // outlier
            outlierFormName: "",
            outlierForm: {
                variable: ""
            },

            // histogram
            histogramVarOptions: [],
            disableHistogramFields: false,
            histogramFormName: "",
            histogramForm: {
                variable: "",
                step: null,
                bars: null,
                min: null,
                max: null
            },

            // boxplot
            boxplotVarOptions: [],
            boxplotFormName: "",
            boxplotForm: {
                targetVariable: "",
                calculationMethod: "",
                filterVariable: "",
                filterVariableValues: []
            },

            // 2AFC
            twoAfcFormName: "",
            twoAfcForm: {
                variableA: "",
                variableB: "",
                chosenVariable: ""
            },
            variableA: props.variableA,
            variableB: props.variableB,
            chosenVariable: props.chosenVariable,
            alert: null,
            loading: false
        };

        // bindings
        this.handleOutlierFormChange = this.handleOutlierFormChange.bind(this);
        this.handleHistogramFormChange = this.handleHistogramFormChange.bind(this);
        this.handleBoxplotFormChange = this.handleBoxplotFormChange.bind(this);
        this.handleTwoAfcFormChange = this.handleTwoAfcFormChange.bind(this);

        this.handleOutlierFormSubmit = this.handleOutlierFormSubmit.bind(this);
        this.handleHistogramFormSubmit = this.handleHistogramFormSubmit.bind(this);
        this.handleBoxplotFormSubmit = this.handleBoxplotFormSubmit.bind(this);
        this.handleTwoAfcFormSubmit = this.handleTwoAfcFormSubmit.bind(this);

        this.updateData = this.updateData.bind(this);
        this.addBoxplotFilterValue = this.addBoxplotFilterValue.bind(this);
        this.getIntendedCalculation = this.getIntendedCalculation.bind(this);
    }

    // outlier form change
    handleOutlierFormChange = (e) => {
        if (e.target.name === "name") {
            this.setState({ outlierFormName: e.target.value });
        } else {
            this.setState(prev => ({
                outlierForm: {
                    ...prev.outlierForm,
                    variable: e.target.value
                }
            }));
        }
    };

    // histogram form change
    handleHistogramFormChange = (e) => {
        if (e.target.name === "name") {
            this.setState({histogramFormName: e.target.value});
        } else if (e.target.name === "variable") {
            this.setState(prevState => ({
                histogramForm: {
                    ...prevState.histogramForm, variable: e.target.value
                },
                disableHistogramFields: e.target.options[e.target.selectedIndex].getAttribute('data-is-string') === 'true'
            }));
        } else if (e.target.name === "step") {
            this.setState(prevState => ({
                histogramForm: {
                    ...prevState.histogramForm, step: (e.target.value) ? parseInt(e.target.value) : null
                }
            }));
        } else if (e.target.name === "bars") {
            this.setState(prevState => ({
                histogramForm: {
                    ...prevState.histogramForm, bars: (e.target.value) ? parseInt(e.target.value) : null
                }
            }));
        } else if (e.target.name === "min") {
            this.setState(prevState => ({
                histogramForm: {
                    ...prevState.histogramForm, min: (e.target.value) ? parseInt(e.target.value) : null
                }
            }));
        } else if (e.target.name === "max") {
            this.setState(prevState => ({
                histogramForm: {
                    ...prevState.histogramForm, max: (e.target.value) ? parseInt(e.target.value) : null
                }
            }));
        }
    }

    // boxplot form change
    handleBoxplotFormChange = (e) => {
        if (e.target.name === "name") {
            this.setState({boxplotFormName: e.target.value});
        } else if (e.target.name === "targetVariable") {
            let method = this.getIntendedCalculation(e.target.value);
            this.setState(prevState => ({
                boxplotForm: {
                    ...prevState.boxplotForm,
                    targetVariable: e.target.value,
                    calculationMethod: method
                }
            }));
        } else if (e.target.name === "calculationMethod") {
            this.setState(prevState => ({
                boxplotForm: {
                    ...prevState.boxplotForm, calculationMethod: e.target.value
                }
            }));
        } else if (e.target.name === "filterVariable") {
            let firstValue = this.state.chartsData.filterVariableValues[e.target.value][0];
            if (!firstValue) {
                this.showAlert({
                    type: "error",
                    message: "There is no data for this filter variable, cannot set."
                });
                return;
            }

            this.setState(prevState => ({
                boxplotForm: {
                    ...prevState.boxplotForm, filterVariable: e.target.value,
                    filterVariableValues: (firstValue ? [firstValue] : [])
                }
            }));
        } else if (e.target.name === "filterVariableValues") {
            let inputIndex = e.target.getAttribute('data-input-index');
            let valuesList = this.state.boxplotForm.filterVariableValues;
            valuesList[inputIndex] = e.target.value;

            this.setState(prevState => ({
                boxplotForm: {
                    ...prevState.boxplotForm, filterVariableValues: valuesList
                }
            }));
        }
    }

    // 2AFC form change
    handleTwoAfcFormChange = (e) => {
        if (e.target.name === "name") {
            this.setState({twoAfcFormName: e.target.value});
        } else {
            this.setState(prev => ({
                twoAfcForm: {
                    ...prev.twoAfcForm,
                    [e.target.name]: e.target.value
                }
            }));
        }
    };

    // outlier form submit
    handleOutlierFormSubmit = (e) => {
        e.preventDefault();

        const {variable} = this.state.outlierForm;

        if (this.state.outlierFormName === "") {
            this.showAlert({
                type: "error",
                message: "Name field must not be empty."
            });
            return;
        }
        if (!variable) {
            this.showAlert({
                type: "error",
                message: "Variable must be selected."
            });
            return;
        }

        createChart(
            this.state.jwtToken,
            "OUTLIER",
            this.state.outlierFormName,
            this.state.id,
            this.state.outlierForm
        ).then(response => {
            if (response.ok) {
                this.showAlert({
                    type: "success",
                    message: "Outlier Detection saved successfully."
                });
                this.updateData();
            } else {
                this.showChartSaveError(response, "Outlier Detection could not be saved.");
            }
        });
    };

    // histogram form submit
    handleHistogramFormSubmit = (e) => {
        e.preventDefault();
        if (this.state.histogramFormName === "") {
            this.showAlert({
                type: "error",
                message: "Name field must not be empty."
            });
            return;
        } else if (this.state.histogramForm.variable === "") {
            this.showAlert({
                type: "error",
                message: "Variable field must not be empty."
            });
            return;
        } else if (isNaN(this.state.histogramForm.step)) {
            this.showAlert({
                type: "error",
                message: "Step size field must be a number or empty."
            });
            return;
        } else if (isNaN(this.state.histogramForm.bars)) {
            this.showAlert({
                type: "error",
                message: "Bar count field must be a number or empty."
            });
            return;
        } else if (isNaN(this.state.histogramForm.min)) {
            this.showAlert({
                type: "error",
                message: "Min field must be a number or empty."
            });
            return;
        } else if (isNaN(this.state.histogramForm.max)) {
            this.showAlert({
                type: "error",
                message: "Max field must be a number or empty."
            });
            return;
        }

        let formData = {...this.state.histogramForm};
        if (this.state.disableHistogramFields){
            formData.step=null;
            formData.bars=null;
            formData.min=null;
            formData.max=null;
        }

        createChart(this.state.jwtToken, "HISTOGRAM", this.state.histogramFormName, this.state.id, formData)
        .then(response =>
            {
                if (response.ok) {
                    this.showAlert({
                        type: "success",
                        message: "Histogram saved successfully."
                    });
                    this.updateData();
                } else {
                    this.showChartSaveError(response, "Histogram could not be saved.");
                }
            }
        );
    }

    // boxplot form submit
    handleBoxplotFormSubmit = (e) => {
       e.preventDefault();
       if (this.state.boxplotFormName === "") {
           this.showAlert({
               type: "error",
               message: "Name field must not be empty."
           });
           return;
       } else if (this.state.boxplotForm.targetVariable === "") {
           this.showAlert({
               type: "error",
               message: "Target variable field must not be empty."
           });
           return;
       } else if (this.state.boxplotForm.calculationMethod === "") {
           this.showAlert({
               type: "error",
               message: "Calculation method field must not be empty."
           });
           return;
       } else if (this.state.boxplotForm.filterVariable === "") {
           this.showAlert({
               type: "error",
               message: "Filter variable field must not be empty."
           });
           return;
       } else if (this.state.boxplotForm.filterVariableValues.length === 0) {
           this.showAlert({
               type: "error",
               message: "At least 1 filter variable value must be set."
           });
           return;
       }

       createChart(this.state.jwtToken, "BOXPLOT", this.state.boxplotFormName, this.state.id, this.state.boxplotForm)
       .then(response =>
           {
               if (response.ok) {
                   this.showAlert({
                       type: "success",
                       message: "Boxplot saved successfully."
                   });
                   this.updateData();
               } else {
                   this.showChartSaveError(response, "Boxplot could not be saved.");
               }
           }
       );
    }

    // 2AFC form submit
    handleTwoAfcFormSubmit = (e) => {
        e.preventDefault();

        const {variableA, variableB, chosenVariable} = this.state.twoAfcForm;

        if (this.state.twoAfcFormName === "") {
            this.showAlert({
                type: "error",
                message: "Name field must not be empty."
            });
            return;
        }
        if (!variableA || !variableB || !chosenVariable) {
            this.showAlert({
                type: "error",
                message: "All 3 variables must be selected."
            });
            return;
        }
        if (variableA === variableB) {
            this.showAlert({
                type: "error",
                message: "Variable A and Variable B must be different."
            });
            return;
        }

        createChart(
            this.state.jwtToken,
            "TWOAFC",
            this.state.twoAfcFormName,
            this.state.id,
            this.state.twoAfcForm
        ).then(response => {
            if (response.ok) {
                this.showAlert({
                    type: "success",
                    message: "2AFC saved successfully."
                });
                this.updateData();
            } else {
                this.showChartSaveError(response, "2AFC could not be saved.");
            }
        });
    };

    // boxplot filter val
    addBoxplotFilterValue = (e) => {
        e.preventDefault();
        if (!this.state.boxplotForm.filterVariable) {
            this.showAlert({
                type: "error",
                message: "No filter variable is selected."
            });
            return;
        }
        let filterValList = this.state.chartsData.filterVariableValues[this.state.boxplotForm.filterVariable];
        let firstValue = filterValList[0];
        if (!firstValue) {
            this.showAlert({
                type: "error",
                message: "There is no data for this filter variable, cannot set."
            });
            return;
        }
        if (this.state.boxplotForm.filterVariableValues.length >= filterValList.length) {
            this.showAlert({
                type: "error",
                message: "Too many fields, this variable gathered only " + (filterValList.length - 1) + " unique value(s)."
            });
            return;
        }

        let valuesList = this.state.boxplotForm.filterVariableValues;
        valuesList.push(firstValue);
        this.setState(prevState => ({
            boxplotForm: {
                ...prevState.boxplotForm, filterVariableValues: valuesList
            }
        }));
    }

    // alert
    showAlert = (alert) => {
        this.setState({alert});
    };

    showChartSaveError = (response, fallbackMessage) => {
        response.json().then(body => {
            const msg = (body?.message || "").toLowerCase();
            if (msg.includes("already has a chart") || msg.includes("chart with this name")) {
                this.showAlert({ type: "error", message: "A chart with this name already exists in this part. Please choose a different name." });
            } else {
                this.showAlert({ type: "error", message: fallbackMessage });
            }
        }).catch(() => this.showAlert({ type: "error", message: fallbackMessage }));
    };

    // update
    updateData() {
        const scrollY = window.scrollY;

        document.documentElement.style.overflowAnchor = "none";

        this.setState({ loading: true, chartsData: null });

        const fetchPromise = getPartChartsDetail(this.state.jwtToken, this.state.id);
        const delayPromise = new Promise(resolve => setTimeout(resolve, 100));

        Promise.all([fetchPromise, delayPromise])
            .then(([response]) => {
                if (response) {
                    this.setState({ chartsData: response, loading: false }, () => {
                        setTimeout(() => {
                            window.scrollTo(0, scrollY);
                            document.documentElement.style.overflowAnchor = "";
                        }, 200);
                    });
                } else {
                    setTimeout(() => this.updateData(), 300);
                }
            });
    }

    // mount
    componentDidMount() {
        this.updateData();
    }

    // calc
    getIntendedCalculation(targetVariableName) {
        let method = "";
        for (var i = 0; i < this.state.chartsData.targetVariables.length; i++) {
            if (this.state.chartsData.targetVariables[i].name === targetVariableName) {
                method = this.state.chartsData.targetVariables[i].calculationMethod;
                break;
            }
        }
        return method;
    }

    render() {
        let renderedOutlierOptions = []
        let renderedOutliers = []
        let renderedHistogramOptions = []
        let renderedHistograms = []
        let renderedBoxplotTargetOptions = []
        let renderedBoxplotFilterOptions = []
        let renderedBoxplotFilterValues = []
        let renderedBoxplots = []
        let twoAfcOptions = []
        let twoAfcs = []
        let intendedCalculationTitle = ""

        if (this.state.chartsData != null) {
            // add form variable options for histogram + targetVariableBoxplot + filterVariableBoxplot
            // (rendering depends on data from backend)
            for (let i = 0; i < this.state.chartsData.targetVariables.length; i++) {
                let option = (<option key={i}
                     value={this.state.chartsData.targetVariables[i].name}
                     name={this.state.chartsData.targetVariables[i].name}
                     data-is-string={false}
                >{this.state.chartsData.targetVariables[i].name}</option>);

                renderedHistogramOptions.push(option);
                renderedBoxplotTargetOptions.push(option);
            }
            for (let i = 0; i < this.state.chartsData.filterVariables.length; i++) {
                let option = (<option key={i + this.state.chartsData.targetVariables.length}
                      value={this.state.chartsData.filterVariables[i].name}
                      name={this.state.chartsData.filterVariables[i].name}
                      data-is-string={true}
                >{this.state.chartsData.filterVariables[i].name}</option>);

                renderedHistogramOptions.push(option);
                renderedBoxplotFilterOptions.push(React.cloneElement(option, {key: i}));
            }

            // add boxplot form filter variable values
            // (rendering depends mostly on what has been inputted so far + backend data)
            var possibleFilterValues = this.state.chartsData.filterVariableValues[this.state.boxplotForm.filterVariable];
            for (let i = 0; i < this.state.boxplotForm.filterVariableValues.length; i++) {
                let select = (<select key={i} data-input-index={i} className="form-control"
                    style={{marginRight:"10px", marginBottom:"5px", width:"fit-content", display:"inline-block"}}
                    value={this.state.boxplotForm.filterVariableValues[i]} name="filterVariableValues"
                    onChange={(e) => this.handleBoxplotFormChange(e)} >
                    { possibleFilterValues?.map((value, key) => {
                        return (<option key={key} value={value} name={value}>{value}</option>);
                    })}
                </select>);
                renderedBoxplotFilterValues.push(select);
            }

            // add histogram graphs
            for (let i = 0; i < this.state.chartsData.histograms.length; i++) {
                renderedHistograms.push(
                    <PartHistogramPanel
                        key={i}
                        histogramIndex={i}
                        jwtToken={this.state.jwtToken}
                        handleUpdate={this.updateData}
                        histogramData={this.state.chartsData.histograms[i]}
                    />
                );
            }

            // add boxplot graphs
            for (let i = 0; i < this.state.chartsData.boxplots.length; i++) {
                renderedBoxplots.push(
                    <PartBoxplotPanel
                        key={i}
                        boxplotIndex={i}
                        jwtToken={this.state.jwtToken}
                        handleUpdate={this.updateData}
                        boxplotData={this.state.chartsData.boxplots[i]}
                    />
                );
            }

            // set title messages
            if (this.state.boxplotForm.targetVariable) {
                let method = this.getIntendedCalculation(this.state.boxplotForm.targetVariable);
                if (method === "LOG_TRANSFORMATION") intendedCalculationTitle = "Intended calculation for this variable:\nLOG TRANSFORMATION"
                else if (method === "NORMAL_DISTRIBUTION") intendedCalculationTitle = "Intended calculation for this variable:\nNORMAL DISTRIBUTION"
                else if (method === "BINOMIAL_DISTRIBUTION") intendedCalculationTitle = "Intended calculation for this variable:\nBINOMIAL DISTRIBUTION"
            }
        }

        return (
            <>
                <script src="https://d3js.org/d3.v7.min.js"></script>
                <div className="row" style={{marginLeft: "4%", marginRight: "4%", marginBottom: "30px"}}>
                    {this.state.alert && (
                        <AlertBox
                            type={this.state.alert.type}
                            message={this.state.alert.message}
                            onClose={() => this.setState({alert: null})}
                        />
                    )}
                    <h1>
                        <Link to="/">
                            <span title="Return to experiment listing">All Experiments</span>
                        </Link>
                        <span>/</span>
                        {(this.state.chartsData?.shared) ?
                            <Link to="/shared">
                                <span title="Return to shared experiment listing">Shared/</span>
                            </Link> : <></>
                        }
                        <Link to={"/detail/" + this.state.chartsData?.experimentId}>
                            <span title="Return to experiment detail">Detail</span>
                        </Link>
                        <span>/</span>
                        {this.state.chartsData?.partName}
                    </h1>
                    <p className="small">{this.state.chartsData?.partDescription}</p>
                    <SectionTwoAfc jwtToken={this.state.jwtToken}
                                   twoAfcForm={this.state.twoAfcForm}
                                   twoAfcFormName={this.state.twoAfcFormName}
                                   twoAfcVarOptions={renderedHistogramOptions}
                                   onFormChange={this.handleTwoAfcFormChange}
                                   onFormSubmit={this.handleTwoAfcFormSubmit}
                                   twoAfcs={this.state.chartsData?.twoAfcs ?? []}
                                   handleUpdate={this.updateData}
                                   showAlert={this.showAlert}
                                   loading={this.state.loading}/>

                    <SectionOutlier jwtToken={this.state.jwtToken}
                                    outlierForm={this.state.outlierForm}
                                    outlierFormName={this.state.outlierFormName}
                                    outlierVarOptions={renderedHistogramOptions}
                                    onFormChange={this.handleOutlierFormChange}
                                    onFormSubmit={this.handleOutlierFormSubmit}
                                    outliers={this.state.chartsData?.outliers ?? []}
                                    twoAfcs={this.state.chartsData?.twoAfcs ?? []}
                                    handleUpdate={this.updateData}
                                    showAlert={this.showAlert}
                                    loading={this.state.loading}/>

                    <SectionHistogram jwtToken={this.state.jwtToken}
                                      histogramForm={this.state.histogramForm}
                                      histogramFormName={this.state.histogramFormName}
                                      histogramVarOptions={renderedHistogramOptions}
                                      disableHistogramFields={this.state.disableHistogramFields}
                                      onFormChange={this.handleHistogramFormChange}
                                      onFormSubmit={this.handleHistogramFormSubmit}
                                      histograms={this.state.chartsData?.histograms ?? []}
                                      handleUpdate={this.updateData}
                                      showAlert={this.showAlert}
                                      loading={this.state.loading}/>

                    <SectionBoxplot jwtToken={this.state.jwtToken}
                                    boxplotForm={this.state.boxplotForm}
                                    boxplotFormName={this.state.boxplotFormName}
                                    boxplotTargetOptions={renderedBoxplotTargetOptions}
                                    boxplotFilterOptions={renderedBoxplotFilterOptions}
                                    boxplotFilterValues={renderedBoxplotFilterValues}
                                    onFormChange={this.handleBoxplotFormChange}
                                    onAddFilterValue={this.addBoxplotFilterValue}
                                    onFormSubmit={this.handleBoxplotFormSubmit}
                                    boxplots={this.state.chartsData?.boxplots ?? []}
                                    handleUpdate={this.updateData}
                                    showAlert={this.showAlert}
                                    loading={this.state.loading}/>
                </div>
            </>
        );
    }
}

export default PartChartsView;
